import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../plugins/vuex'

import Home1 from '../views/Home1.vue'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import NotFound from '../views/NotFound.vue'
import Comune from '../views/backoffice/Comune.vue'
import Accesso from '../views/backoffice/Accesso.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home1',
    component: Home1
  },

  {
    path: '/backoffice/:cid',
    name: 'BackOffice',
    component: Comune,
    props: route => ({ cid: route.params.cid })
  },
  {
    path: '/admin',
    name: 'LogComune',
    component: Accesso
  },
  {
    path: '/notfound/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:cid',
    name: 'Home',
    component: Home
  },

  {
    path: '/about/:Sid',
    name: 'About',
    component: About,
    props: route => ({ Sid: route.params.Sid })
  },

  { path: '/*', redirect: '/notfound/404' }

]

const router = new VueRouter({
  mode: 'history',
  base: '/segnalazioni',
  routes,
  store
})

export default router
